export const state = {
    contrato: '',
    modalVisualizarContrato: false
}

export default {}